/*
 *
 * ConfirmReverseTransactionModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 30-Jun-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doShowPopup, doHidePopup } from 'Store/actions/popup'
import * as TransactionsActions from '../../routes/Transactions/modules/TransactionsActions'
import { nullSafe } from 'Utility/globalMethods'
import ConfirmReverseTransactionModal from './ConfirmReverseTransactionModal'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TransactionsActions, dispatch),
  ...bindActionCreators({ doShowPopup, doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading.transaction_refund, false),
  amount: nullSafe(() => state.popup.popupInfo.amount, ''),
  refundTransaction: nullSafe(() => state.Transactions.refundTransaction, {}),
  partiallyRefundable: nullSafe(() => state.Transactions.accountedTransactionDetails.refundData.partiallyRefundable, false),
  selectedTab: nullSafe(() => state.global.selectedTab, ''),
  transactionDetails: nullSafe(() => state.Transactions.authorizedTransactionDetails || state.Transactions.accountedTransactionDetails, {}),
  transactionTabDetails: nullSafe(() => state.Transactions.authorizedTransactionTabsDetails || state.Transactions.accountedTransactionTabsDetails, {})
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ConfirmReverseTransactionModal)
